'use strict';

exports.__esModule = true;

var _isClassComponent = require('./isClassComponent');

var _isClassComponent2 = _interopRequireDefault(_isClassComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isReferentiallyTransparentFunctionComponent = function isReferentiallyTransparentFunctionComponent(Component) {
  return Boolean(typeof Component === 'function' && !(0, _isClassComponent2.default)(Component) && !Component.defaultProps && !Component.contextTypes);
};

exports.default = isReferentiallyTransparentFunctionComponent;


//////////////////
// WEBPACK FOOTER
// ./~/recompose/isReferentiallyTransparentFunctionComponent.js
// module id = 1070
// module chunks = 0